import { microServices } from "../config/global";
import apiService from "../redux/apiService";
import { preparePropertiesList,preparePropertyGroup } from "./utils";


export const loadPropertyNameOptions = (inputValue, loginType = '', type, filterByCompnay = []) => {
  let userType = type
  if (loginType !== '') {
    //loginType passed from CL/PM Common Components Only
    userType = loginType ? 'cleaner' : 'manager';
  }
  let endPt = microServices.base + '/v1/property/' + userType + '?filter[property_name]=' + inputValue;

  if (filterByCompnay.length > 0) {
      if(userType=='cleaner'){
        let ids =[];
        filterByCompnay.map((id)=>{
          ids.push(id.value);
        })
        endPt+='&filter[manager_id]='+ids.toString();
      }
      if(userType=='manager'){
        let ids =[];
        filterByCompnay.map((id)=>{
          ids.push(id.value);
        })
        endPt+='&filter[clenaer_id]='+ids.toString();
      }
  }
  endPt += '&per_page=0';
  if (inputValue.length >= 3) {
    return apiService.get(endPt)
      .then((response) => { return preparePropertiesList(response, userType) });
  }
}

export const loadAdminPropertyNameOptions = (inputValue, loginType='', type) => {
  if (inputValue.length >= 3) {
    return apiService.get(microServices.base + '/v1/admin/properties?filter[property_name]=' + inputValue + '&per_page=0')
      .then((response) => { return preparePropertyGroup(response) });
  }
}

export  const filterPropertyOptions = async (type, filterByCompnay = []) => {
  
  let endPt  = microServices.base + '/v1/property/';
  if (type =='cleaner') {
    let fiterUrl1 = (filterByCompnay.length >0) ? '?filter[manager_id]='+filterByCompnay.toString()+ '&per_page=0' : '?per_page=0' ;
    endPt += type + fiterUrl1
  } else if (type =='manager') {
    let fiterUrl2 = (filterByCompnay.length >0) ? '?filter[cleaner_id]='+filterByCompnay.toString()+ '&per_page=0' : '?per_page=0' ;
    endPt += type + fiterUrl2
  }
  return await apiService.get(endPt)
    .then((response) => { return  preparePropertiesList(response, type) });
}

export const LOCAL_IVR =13002;


export const filterServiceByPmService =(services,pmId='',clId)=>{
  let serviceList = [
    {
      label: "",
      options: [],
    },
    {
      label: "Manager Service",
      options: [],
    }
  ];
  if(services){
   let selfService =  services.filter((ser=>{
      return ser.created_by_company == clId
    }))
    let pmService =[];
    if(pmId == ''){
       pmService =  services.filter((ser=>{
        return ser.created_by_company!=clId
      }))
    }else{
      pmService =  services.filter((ser=>{
        return ser.created_by_company==pmId
      }))
    }
   
    serviceList = [{
      label: "",
      options: selfService,
    },
    {
      label: (pmService.length > 0) ? "Manager Service" :'',
      options: pmService,
    }];
   
  }
  return serviceList
}

export const filterServiceByClService =(services,pmId)=>{
 
  let serviceList = [
    {
      label: "Internal service",
      options: [],
    },
    {
      label: "Outside Service",
      options: [],
    }
  ];
  if(services){
   let outsideService =  services.filter((ser=>{
      return (ser.created_by_company == pmId && ser.company_id!=pmId)
    }))
    let internalService =[];
 
      internalService =  services.filter((ser=>{
        return ser.created_by_company == pmId && ser.company_id==pmId
      }))
   
    serviceList = [{
      label: "",
      options: internalService,
    },
    {
      label: (outsideService.length > 0) ? "Oustside Service" :'',
      options: outsideService,
    }];
   
  }
  return serviceList
}